// React
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Redux
import { useSelector } from "react-redux";
import { selectPatient } from "Store/PatientSlice";
import { selectClient } from "Store/ClientSlice";

// MUI
import { Box, Alert, Collapse, IconButton, Stack } from "@mui/material";

// Icons
import { Close, InfoOutlined } from "@mui/icons-material";

// Components
import { PatientInfoHeader } from "Common/Components";
import AvailableAppointments from "Components/Appointments/AvailableAppointments";

// Libraries
import ReactMarkdown from "react-markdown";

// Styles
import { styles } from "Components/Appointments/styles";

const Appointments = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [openBanner, setOpenBanner] = useState(true);
  const reasonForVisit = location.state?.reasonForVisit || "";
  const additionalInfo = location.state?.additionalInfo || "";
  const selectedLocation = location.state?.location || "";
  const initialSlots = location.state?.availableSlots || [];
  const locationInfo = location.state?.locationInfo;

  const patient = useSelector(selectPatient);
  const client = useSelector(selectClient);

  return (
    <Stack px={{ xs: 2, sm: 4, md: 10 }}>
      <PatientInfoHeader
        onBackClick={() => navigate("/")}
        patient={patient}
        title={t("viewMoreAppointmentsModal.availableAppointments")}
      />
      {locationInfo?.[i18n.language] && (
        <Box sx={{ width: "100%" }}>
          <Collapse in={openBanner}>
            <Alert
              icon={false}
              sx={styles.banner}
              action={
                <IconButton
                  aria-label="close-banner"
                  color="primary"
                  onClick={() => setOpenBanner(false)}
                >
                  <Close fontSize="small" />
                </IconButton>
              }
            >
              <ReactMarkdown
                components={{
                  a: ({ node, children, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer">
                      {children}
                    </a>
                  ),
                }}
              >
                {locationInfo[i18n.language]}
              </ReactMarkdown>
            </Alert>
          </Collapse>
          {!openBanner && (
            <Box sx={styles.bannerInfoIcon}>
              <IconButton
                aria-label="expand-banner"
                color="primary"
                onClick={() => setOpenBanner(true)}
              >
                <InfoOutlined fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
      )}
      <AvailableAppointments
        patient={patient}
        client={client}
        reasonForVisit={reasonForVisit}
        additionalInfo={additionalInfo}
        selectedLocation={selectedLocation}
        initialSlots={initialSlots}
      />
    </Stack>
  );
};

export default Appointments;
